import { ENDPOINTS } from "Config/endpoints";
import protectedApi from "Config/protectedApi";


export const getDyanmicUiFn = (reqBody) => {
    try {
        const response = protectedApi.get(ENDPOINTS.page_ui, {
            params: reqBody,
        });
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};



export const deleteDyanmicUiFn = (reqBody) => {
    try {
        const response = protectedApi.delete(ENDPOINTS.page_ui, {
            data: reqBody,
        });
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};

export const patchDyanmicUiFn = (reqBody, url) => {
    try {
        const response = protectedApi.patch(ENDPOINTS.page_ui, reqBody);
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};

export const postDyanmicUiFn = (reqBody, url) => {
    try {
        const response = protectedApi.post(ENDPOINTS.page_ui, reqBody);
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};

